import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";


export class FormUtil {

  validateForm(formGroup: FormGroup): boolean {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      } else if (control instanceof FormArray) {
        (control as FormArray).controls.forEach((group) => this.validateForm(group as FormGroup));
      }
    });

    return formGroup.valid;
  }

  validateFormControl(control: FormControl | FormArray): boolean {
    let isInvalid = control.invalid;

    if (isInvalid) {
      control.markAsTouched({ onlySelf: true });
    }
    return !isInvalid;
  }

  // parse a date in yyyy-mm-dd format
  parseDate(input) {
    var parts = input.match(/(\d+)/g);
    // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
    return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
  }


}

export class FormUtilMasks {
  static phoneMask = ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,];
  static dateMask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[1-2]/, /([0|9])/, /[0-9]/, /[0-9]/];
  static cpfMask = [/[0-9]/, /\d/, /\d/, '.', /[0-9]/, /\d/, /\d/, '.', /[0-9]/, /\d/, /\d/, '-', /[0-9]/, /\d/,];
  static currency = /^\d(\d|\,\d{3}|,\d.+$)*$/;

  static cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  static cellMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  // landlineMask = mascara telefone fixo
  static landlineMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  static cepMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  static birthDateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  static hoursMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  static nitMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/];


  static formatReal(value: string) {
    debugger
    let sanitized = value.replace(",", "").replace(".", "");
    let valueNumber = parseInt(sanitized);
    return valueNumber.toLocaleString("pt-PT", { minimumFractionDigits: 2 });
  }
}

export class FormUtilFormatter {

  static formatCpf(value: string) {
    if (!value || value.length == 0) return "";
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  static formatCnpj(value: string) {
    if (!value || value.length == 0) return "";
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
  }

  static formatDateYyyyMmDd(value: string) {
    if (!value || value.length == 0) return "";
    if (value.length != 10) return "";
    return value.split("/").reverse().join("-");
  }

  static formatDateYyyyMmDdHhMm(value: string) {
    return FormUtilFormatter.formatDateYyyyMmDd(value) + "T00:00";
  }

  /// @param [date] string no formato "dd/MM/YYYY"
  /// @param [currentDate] new Date()
  static isDateDdMmYyyyGreaterThanOrEqualCurrentDate(date: string, currentDate: Date = new Date()) {
    const dateStringFormated = FormUtilFormatter.formatDateYyyyMmDdHhMm(date);
    const dateInformed = new Date(dateStringFormated);
    currentDate.setHours(0, 0, 0, 0);
    return dateInformed >= currentDate;
  }
}

export class FormUtilValidators {

  static date(control: AbstractControl): { [key: string]: boolean } | null {

    if (control.value == undefined || (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(control.value))) {
      return { invalid: true };
    }

    const validYear = new Date().getFullYear() - 18;
    const [d, m, y] = control.value.split('/')
    const day = d < 0 || d > 31 ? false : true;
    const month = m < 1 || m > 12 ? false : true;
    const year = y > validYear && parseInt(y, 10) < 1900 ? false : true;

    if (y < 1870) {
      return { invalid: true };
    }

    if (!day || !month || !year) {
      return { invalid: true };
    }

    return null;
  }

  static sinceCurrentDate(control: AbstractControl): { [key: string]: boolean } | null {

    const dateInvalid = FormUtilValidators.date(control);
    if (dateInvalid != null) return dateInvalid;

    const isGreaterOrEqual = FormUtilFormatter.isDateDdMmYyyyGreaterThanOrEqualCurrentDate(control.value);

    if (isGreaterOrEqual == false) {
      return { invalid: true };
    }

    return null;
  }

  // TODO: implementar Validator
  static email(email, formControl: FormControl) {
    if (!/\S+@\S+\.\S+/.test(email)) {
      formControl.setErrors({ invalid: true });
      return { invalid: true };
    }

    formControl.setErrors(null);
    return { invalid: false };
  }

  // TODO: implementar Validator
  static phone(phone, formControl: FormControl) {
    if (!/^[(]\d{2}[)]\d{5}-\d{4}/.test(phone)) {
      formControl.setErrors({ invalid: true });
      return { invalid: true };
    }

    formControl.setErrors(null);
    return { invalid: false };
  }

  // TODO: implementar Validator
  static notSpecialCharacters(event: KeyboardEvent) {
    switch (event.keyCode) {
      case 8:  // Backspace
      case 9:  // Tab
      case 13: // Enter
      case 37: // Left
      case 38: // Up
      case 39: // Right
      case 40: // Down
        break;
      default:
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        // var regex = new RegExp("^[a-zA-Z0-9.,/ $@()]+$");
        var key = event.key;
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
        break;
    }
  }

  // TODO: implementar Validator
  static cpf(param, formControl: FormControl) {

    const val = param.replace(/[-.]/gi, "");

    if (
      val == null ||
      val.length < 11 ||
      val == "00000000000" ||
      val == "11111111111" ||
      val == "22222222222" ||
      val == "33333333333" ||
      val == "44444444444" ||
      val == "55555555555" ||
      val == "66666666666" ||
      val == "77777777777" ||
      val == "88888888888" ||
      val == "99999999999"
    ) {
      formControl.setErrors({ invalid: true });
      return { invalid: true };
    }

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      formControl.setErrors({ invalid: true });
      return { invalid: true };
    };
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      formControl.setErrors({ invalid: true });
      return { invalid: true };
    };
    formControl.setErrors(null);
    return { invalid: false };
  }

}